import Skeleton from "react-loading-skeleton";
import { InfoCard } from "../../components/cards/infoCard";
import { EmptyState } from "../../components/empty";
import { Icon } from "../../components/icon/icon";
import { AddPayoutAccountModal } from "../../components/modal/app_modals/addPayoutAccountModal";
import { MiniHeader } from "../../components/typography/miniHeader";
import { BgWrapper } from "../../components/wrapper/bgWrapper";
import { useModalControl } from "../../customeHooks/useModalControl";
import { useGetPayoutAccountQuery } from "../../redux/features/payment/payment.api";
import {
  SKELETON_BASE_COLOR,
  SKELETON_HIGHLIGHT_COLOR,
} from "../../utils/constants";

export const PayoutSettings = () => {
  const { modalOpen, modal, handleModalClose, handleModalOpen } =
    useModalControl();

  const {
    data: payoutAccount,
    isFetching: fetchingPayoutAccount,
    refetch,
  } = useGetPayoutAccountQuery({}, { refetchOnMountOrArgChange: true });

  return (
    <>
      {fetchingPayoutAccount ? (
        <BgWrapper className="flex flex-col gap-4">
          <Skeleton
            width={"100%"}
            height={43}
            className="rounded-2xl"
            baseColor={SKELETON_BASE_COLOR}
            highlightColor={SKELETON_HIGHLIGHT_COLOR}
          />
        </BgWrapper>
      ) : undefined}

      {!!payoutAccount?.data && !fetchingPayoutAccount && (
        <BgWrapper className="flex flex-col gap-4">
          <div className="flex items-center gap-3">
            <Icon svg="bank" width={24} height={24} className="text-success" />

            <div className="flex-1">
              <MiniHeader
                header={`${payoutAccount?.data?.accountName}`}
                subheader={`${payoutAccount?.data?.accountNumber} ∙ ${payoutAccount?.data?.bankName}`}
              />
            </div>

            <button
              className="w-fit"
              type="button"
              onClick={() => {
                handleModalOpen("addPayoutModal");
              }}
            >
              <Icon
                svg="pencil"
                width={20}
                height={20}
                className="text-grey-600"
              />
            </button>
          </div>

          <InfoCard
            leftIcon="info"
            title="You can only add one payout account at a time"
            text="However, you can edit your payout account details"
          />
        </BgWrapper>
      )}

      {!payoutAccount?.data && !fetchingPayoutAccount && (
        <EmptyState
          text="No Bank Account Added"
          subtext="Add bank account as payout details"
          ctaText="Add Bank Account"
          ctaIcon=""
          onCTAClick={() => {
            handleModalOpen("addPayoutModal");
          }}
          textClassName="text-[24px]"
          subtextClassName="-mt-2"
          image="/assets/images/bank-glass.png"
        />
      )}

      <AddPayoutAccountModal
        open={modal === "addPayoutModal" && modalOpen}
        handleClose={() => {
          handleModalClose();
        }}
        onSuccess={() => {
          handleModalClose();
          refetch();
        }}
        mode={!!payoutAccount?.data ? "edit" : "create"}
      />
    </>
  );
};
